// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-operations .btn-sm {
  padding: 0 10px !important;
  margin: 0 !important;
}

.main-operations li:first-child .btn-sm {
  padding: 3px 6px !important;
}

.editDropdown {
  padding: 0 !important;
  top: -11px !important;
}

.editDropdown .dropdown-item {
  padding: 2px 8px !important;
}

.btn.btn-sm[color=light].active, .btn.btn-sm[color=light]:focus {
  padding: 3px 10px !important;
  background: #26a1c7 !important;
  border: solid 1px #6fc0d9 !important;
  color: #fff !important;
}`, "",{"version":3,"sources":["webpack://./src/app/common/header/header.component.scss"],"names":[],"mappings":"AAGA;EACI,0BAAA;EACA,oBAAA;AAFJ;;AAIA;EACI,2BAAA;AADJ;;AAGA;EACI,qBAAA;EACA,qBAAA;AAAJ;;AAEA;EACI,2BAAA;AACJ;;AACA;EACI,4BAAA;EACA,8BAAA;EACA,oCAAA;EACA,sBAAA;AAEJ","sourcesContent":["// i[class^=\"icon\"] {\r\n//     font-size: 15px;\r\n// }\r\n.main-operations .btn-sm{\r\n    padding: 0 10px !important;\r\n    margin: 0 !important;\r\n}\r\n.main-operations li:first-child .btn-sm{\r\n    padding: 3px 6px !important;\r\n}\r\n.editDropdown{\r\n    padding: 0 !important;\r\n    top: -11px !important;\r\n}\r\n.editDropdown .dropdown-item{\r\n    padding: 2px 8px !important;\r\n}\r\n.btn.btn-sm[color=light].active,.btn.btn-sm[color=light]:focus{\r\n    padding: 3px 10px !important;\r\n    background: #26a1c7 !important;\r\n    border:solid 1px #6fc0d9 !important;\r\n    color: #fff !important;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
